import Vue from 'vue/dist/vue.js';
import TweetContentRenderer from "../Components/TweetContentRenderer.vue";

export default Vue.extend({
    components: {
        TweetContentRenderer,
    },
    template: `<tweet-content-renderer :params="this.params"></tweet-content-renderer>`,
});